import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { WithdrawService } from "../api";

export const actionGetMyOrder = createAsyncThunk(
  "withdraw/my-order",
  async (_, { rejectWithValue }) => {
    try {
      const res = await WithdrawService.doGetMyOrder();

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCreateOrder = createAsyncThunk(
  "withdraw/create-order",
  async (data, { rejectWithValue }) => {
    try {
      const res = await WithdrawService.doCreateOrder(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCancelOrder = createAsyncThunk(
  "withdraw/cancel-order",
  async (data, { rejectWithValue }) => {
    try {
      const res = await WithdrawService.doCancelOrder(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const withdrawSlice = createSlice({
  name: "withdraw",
  initialState: {
    myOrder: {
      loading: false,
      data: null,
      error: "",
    },
    createOrder: {
      loading: false,
      data: null,
      error: "",
    },
    cancelOrder: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // actionGetMyOrder
      .addCase(actionGetMyOrder.pending, (state) => {
        state.myOrder.loading = true;
      })
      .addCase(actionGetMyOrder.fulfilled, (state, action) => {
        state.myOrder.loading = false;
        state.myOrder.data = action.payload;
      })
      .addCase(actionGetMyOrder.rejected, (state, action) => {
        state.myOrder.loading = false;
        state.myOrder.data = action.payload;
        state.myOrder.error = action.error.message || "Something went wrong";
      })
      // action create Order
      .addCase(actionCreateOrder.pending, (state) => {
        state.createOrder.loading = true;
      })
      .addCase(actionCreateOrder.fulfilled, (state, action) => {
        state.createOrder.loading = false;
        state.createOrder.data = action.payload;
      })
      .addCase(actionCreateOrder.rejected, (state, action) => {
        state.createOrder.loading = false;
        state.createOrder.data = action.payload;
        state.createOrder.error =
          action.error.message || "Something went wrong";
      })
      // action create Order
      .addCase(actionCancelOrder.pending, (state) => {
        state.cancelOrder.loading = true;
      })
      .addCase(actionCancelOrder.fulfilled, (state, action) => {
        state.cancelOrder.loading = false;
        state.cancelOrder.data = action.payload;
      })
      .addCase(actionCancelOrder.rejected, (state, action) => {
        state.cancelOrder.loading = false;
        state.cancelOrder.data = action.payload;
        state.cancelOrder.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default withdrawSlice.reducer;
export const { actions, reducer } = withdrawSlice;
